/**
 * @generated SignedSource<<8ea18667ff83c9b1d9d1b025cea473f5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type addSalesChannelDialogQuery$variables = Record<PropertyKey, never>;
export type addSalesChannelDialogQuery$data = {
  readonly ecommerceSettings: {
    readonly ecommerceID: number;
    readonly ecommerceName: ECommerce;
    readonly remoteUrl: string | null;
  } | null;
  readonly hasUsedPromotion: boolean;
  readonly planForUpgradeSeller: {
    readonly salesChannelPrice: number;
  } | null;
};
export type addSalesChannelDialogQuery = {
  response: addSalesChannelDialogQuery$data;
  variables: addSalesChannelDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelPrice",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "promotion",
      "value": "FREE_COST_SALES_CHANNEL"
    }
  ],
  "kind": "ScalarField",
  "name": "hasUsedPromotion",
  "storageKey": "hasUsedPromotion(promotion:\"FREE_COST_SALES_CHANNEL\")"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addSalesChannelDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "planForUpgradeSeller",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      (v4/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addSalesChannelDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "planForUpgradeSeller",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      (v4/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "c50934a49e76d5c662414b487ab182d3",
    "id": null,
    "metadata": {},
    "name": "addSalesChannelDialogQuery",
    "operationKind": "query",
    "text": "query addSalesChannelDialogQuery {\n  ecommerceSettings {\n    ecommerceID\n    ecommerceName\n    remoteUrl\n    id\n  }\n  planForUpgradeSeller {\n    salesChannelPrice\n    id\n  }\n  hasUsedPromotion(promotion: FREE_COST_SALES_CHANNEL)\n}\n"
  }
};
})();

(node as any).hash = "d38b466d9e1274310e22d6df7ee80a6a";

export default node;
